// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"91a9eb20","523":"51056e54"}[chunkId] + ".chunk.js";
};